<template>
  <div class="group p-[5px]">
    <SelectViewport>
      <SelectLabel class="px-[25px] text-sm font-normal italic leading-[25px] text-[#8E8D91]">
        {{ groupName }}
      </SelectLabel>

      <SelectGroup><slot></slot></SelectGroup>
    </SelectViewport>
  </div>
</template>

<script setup lang="ts">
import { SelectViewport, SelectLabel, SelectGroup } from "radix-vue";

defineProps({
  groupName: { type: String, required: true },
});
</script>

<style scoped lang="scss">
.group:not(:last-child) {
  @apply border-b border-theme-border;
}
</style>
